import Vue from 'vue'
import Vuex from 'vuex'

// Modules
import app from './app'
import appConfig from './app-config'
import verticalMenu from './vertical-menu'
import auth from './auth'
import image from './utils/image'

import dashboard from './dashboard'
import modules from './module'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    appConfig,
    verticalMenu,
    auth,
    image,

    ...dashboard,

    // other modules
    ...modules,
  },
  strict: process.env.DEV,
})
